import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

export const ModalXacNhanItem = ({ show, onHide, onConfirm, title, message }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleConfirm = () => {
        setIsSubmitting(true);
        Promise.resolve(onConfirm())
            .catch((e) => {
                console.error("Lỗi khi xác nhận:", e);
            })
            .finally(() => {
                setIsSubmitting(false);
                onHide();
            });
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static" className="modal-new modal fade text-left" style={{ zIndex: 1060 }}>
            <Modal.Header>
                <h4 className="modal-title color7-bold">
                    <span className="btn-icon-right"><img src="/app-assets/images/icon-xoa-v2.png" alt="icon" /></span>
                    {title || "Xác nhận"}
                </h4>
                <button type="button" className="close-popup-new" onClick={onHide} disabled={isSubmitting}>
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="form-body text-center">
                    <h5>{message || "Bạn có chắc chắn muốn thực hiện hành động này?"}</h5>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-new-main btn-closenew" onClick={onHide} disabled={isSubmitting}>
                    <span><i className="mdi mdi-close"></i></span>&nbsp; Hủy
                </button>
                <button
                    type="button"
                    className="btn btn-danger" 
                    onClick={handleConfirm}
                    disabled={isSubmitting}
                    style={{ borderRadius: '8px', padding: '10px 20px' }}
                >
                    <span><i className="mdi mdi-check"></i></span>&nbsp; {isSubmitting ? "Đang xử lý..." : "Xác nhận"}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalXacNhanItem;